module.exports = __webpack_public_path__ + "img/xls.87d5d15a.png";